module.exports = __webpack_public_path__ + "static/7-fbe463fe9e941d088c46782547d4a6c4.jpg";